import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";
import { categories } from "@/mocks/categories";
import { formatViews } from "@/utils/manga";

export default function SiteIntro() {
  const totalViews = comics.reduce((sum, item) => sum + item.views, 0);
  const stats = [
    { label: "收录漫画", value: `${comics.length}+`, icon: "ri-book-2-line" },
    { label: "漫画题材", value: `${categories.length}`, icon: "ri-apps-2-line" },
    { label: "累计阅读", value: formatViews(totalViews), icon: "ri-eye-line" },
    { label: "持续更新", value: "每日", icon: "ri-refresh-line" },
  ];

  return (
    <section className="w-full bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-3">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-information-line"></i>
              关于韩漫大全
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
              海量韩漫无删减，下拉阅读更尽兴
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-5 leading-relaxed">
              韩漫大全无删减免费阅读下拉致力于为广大韩漫爱好者打造一个资源丰富、持续更新的在线阅读平台。我们覆盖爱情、奇幻、悬疑、校园等多种热门题材，主打无删减内容，保障阅读的完整性。
            </p>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              无论是高效查找、便捷的下拉式连续阅读，还是快速切换章节与个性化推荐，我们都希望让每一次追漫都轻松顺畅，伴随你在手机和电脑上畅享阅读乐趣。
            </p>
            <div className="flex flex-wrap gap-3 mt-7">
              <Link
                to="/category"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-compass-3-line"></i>
                开始找漫画
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                了解我们
              </Link>
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-2 gap-3 md:gap-4 content-start">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 text-xl mb-3">
                  <i className={stat.icon}></i>
                </span>
                <p className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                  {stat.value}
                </p>
                <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}